// Transition speed
export const transitionSuperFast = '40ms'
export const transitionFast = '60ms'
export const transitionMedium = '80ms'
